import React from 'react';

import IntlMessages from '@src/util/IntlMessages';

import styles from '../styles.module.less';

interface MarkingPortalDataRowProps {
  labelId: string;
  value: string;
}

export const MarkingPortalDataRow: React.FC<MarkingPortalDataRowProps> = ({ labelId, value }) => (
  <div className={styles.dataRow}>
    <span className={styles.dataRowLabel}>
      <IntlMessages id={labelId} />
    </span>
    <span className={styles.dataRowValue}>{value}</span>
  </div>
);
